import type { ReactNode } from 'react';

import { useOnboardingStatus } from '../hooks/use-onboarding-status';

import { CatalogImportRequiredPlaceholder } from './catalog-import-required-placeholder';

interface RequireCatalogImportCompleteProps {
  children: ReactNode;
}

/**
 * Page-level gate for the `/experiments/create` funnel that blocks entry
 * until the aggregate `catalogImportStatus` from `/integration/onboarding/status`
 * resolves to `COMPLETE`. Stacks beneath `RequireChannelConnection` (which
 * verifies a catalog source is connected at all) — this layer answers "has
 * the catalog actually been imported yet?".
 *
 * Loading + error states render children: avoids flashing the placeholder
 * during a cold fetch and keeps the page accessible if the status endpoint
 * is briefly unavailable (downstream queries will surface the real failure).
 */
export function RequireCatalogImportComplete({ children }: RequireCatalogImportCompleteProps) {
  const { data, isLoading, isError } = useOnboardingStatus();
  if (!isLoading && !isError && data && data.catalogImportStatus !== 'COMPLETE') {
    return <CatalogImportRequiredPlaceholder />;
  }
  return <>{children}</>;
}
